export const TRUNCATED_COPY_HEIGHT = {
  // font size * line height * number of lines clamped
  md: 16 * 1.25 * 2,
  sm: 14 * 1.25 * 2,
  xs: 12 * 1.25 * 2,
}
export const TRANSITION_DURATION = 200
